import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantV2Service } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useMerchantInfoQuery = () => {
	const dispatch = useDispatch();

	return useMutation((id: number) => merchantV2Service.getMerchant({ id }), {
		onError(error: ErrorResponse) {
			dispatch(
				uiActions.showErrorNotification({
					title: getErrorMessage(error),
				}),
			);
		},
	});
};

export default useMerchantInfoQuery;
